import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/provide/common.service';
import { environment } from 'src/environments/environment';
import { PhoneFormatPipe } from 'src/app/provide/phone-format.pipe';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/provide/auth.service';

@Component({
    selector: 'profile-layout',
    templateUrl: './profile-layout.component.html',
    styleUrls: ['./profile-layout.component.scss'],
    standalone: false
})
export class ProfileLayoutComponent implements OnInit, OnChanges {
  @Input() data : any
  @Output() on_Click = new EventEmitter
  serviceRole: string;
  showDeleteModal: boolean = false;
  displayCountry: string;
  displayState: string;
  private countryList: any[] = [];
  private stateList: any[] = [];

  constructor(
    private commonService : CommonService,
    private router: Router,
    private authService: AuthService
  ) { 
    this.serviceRole = localStorage.getItem('serviceRole')
  }

  ngOnInit(): void {
    this.resolveLocationLabels();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.resolveLocationLabels();
    }
  }
  
  // Format phone number with country code
  getMobileNumberWithCode(countryCode: string, mobileNumber: string): string {
    if (!countryCode || !mobileNumber) {
      return countryCode || mobileNumber || '';
    }
    
    // Use the static method from PhoneFormatPipe
    return PhoneFormatPipe.formatPhoneWithCountryCode(countryCode, mobileNumber);
  }

  /**
   * Map stored ISO codes for country/state to human‑readable names
   * for display on the profile view.
   */
  private resolveLocationLabels(): void {
    if (!this.data) {
      this.displayCountry = '';
      this.displayState = '';
      return;
    }

    // Defaults (fallback to whatever backend sends)
    this.displayCountry = this.data.country || '';
    this.displayState = this.data.state || '';

    const countryCode: string =
      this.data.countryIsoCode || this.data.country || '';
    const stateCode: string =
      this.data.stateIsoCode || this.data.state || '';

    if (!countryCode) {
      return;
    }

    // Fetch and cache country list
    this.commonService.getApi('user/listCountry', 1).subscribe((res: any) => {
      if (res?.responseCode === 200) {
        this.countryList = res.result || [];

        const countryMatch = this.countryList.find(
          (c: any) =>
            c.isoCode === countryCode ||
            c.isoCode === this.data.countryIsoCode
        );
        if (countryMatch?.name) {
          this.displayCountry = countryMatch.name;
        }
      }

      // Now resolve state name if we have a state code
      if (!stateCode) {
        return;
      }

      const stateApiUrl = `user/listState?countryCode=${countryCode}`;
      this.commonService.getApi(stateApiUrl, 1).subscribe((stateRes: any) => {
        if (stateRes?.responseCode === 200) {
          this.stateList = stateRes.result || [];
          const stateMatch = this.stateList.find(
            (s: any) =>
              s.isoCode === stateCode ||
              s.isoCode === this.data.stateIsoCode ||
              s.name === this.data.state
          );
          if (stateMatch?.name) {
            this.displayState = stateMatch.name;
          }
        }
      });
    });
  }
  
  navigateToViewProduct(e){
    this.on_Click.emit(e)
  }

  updateSpardic(){
    let url = ``
    this.commonService.postApi(url,{},1).subscribe((res)=>{
      
    })
  }
  refferNow(){
    const userType = localStorage.getItem("userType");
    const routes = {
      CUSTOMER: "login",
      RETAILER: "login-retailer",
      SERVICE_PROVIDER: "login-service-provider"
    };
    
    const route = routes[userType] || "login";
    let refferUrl = `${environment.webUrl}${route}?refferalCode=${this.data.refferalCode}`
    this.copyText(refferUrl) 
    if (navigator.share) {
      navigator.share({
        title: 'Join me on eXobe platform!',
        text: `Sign up using my referral link and get a bonus!`,
        url: refferUrl
      })
      .then(() => console.log('Shared successfully'))
      .catch((error) => console.error('Error sharing', error));
    } else {
      console.warn('Web Share API is not supported in your browser.');
    }
   
  }

  copyText(text: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        this.commonService.showSuccessToast("Copied to clipboard.")
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    } else {
      // Fallback for older browsers
      this.fallbackCopyText(text);
    }
  }
  
  private fallbackCopyText(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      this.commonService.showSuccessToast("Copied to clipboard.")
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textarea);
  }

  // Delete Account Modal Methods
  showDeleteAccountModal(): void {
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
  }

  confirmDeleteAccount(): void {
    this.commonService.showSpinner();
    
    // Call the delete user API - using GET method as per API documentation
    this.commonService.getApi('user/deleteUser', 1).subscribe(
      (res: any) => {
        this.commonService.hideSpinner();
        if (res.responseCode === 200) {
          this.commonService.successToast(res.responseMessage || 'Account deleted successfully');
          
          // Clear all local storage manually to redirect to homepage instead of login
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('email');
          localStorage.removeItem('primaryAddressId');
          localStorage.removeItem('userRequestStatus');
          localStorage.removeItem('myId');
          localStorage.removeItem('Ids');
          localStorage.removeItem('completeProfile');
          localStorage.removeItem('serviceRole');
          localStorage.removeItem('token-auth');
          localStorage.removeItem('userDetail');
          
          // Update auth service state
          this.authService.isLoggedIn.next(false);
          this.authService.loggedInUserType.next('');
          
          // Close the modal
          this.closeDeleteModal();
          
          // Navigate to homepage
          this.router.navigate(['/home']);
        } else {
          this.commonService.errorToast(res.responseMessage || 'Failed to delete account');
        }
      },
      (err: any) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast(err.responseMessage || 'Failed to delete account');
      }
    );
  }

}
